import SideFilterFrame from "../../components/common/SideFilterFrame";
import {
  ChallengeCard,
  ChallengeCardLoading,
} from "../../components/challenge/ChallengeCard";
import { useAllChallengeData, useSingleFundData } from "../../lib/hooks";
import { useEffect, useState } from "react";
import { ChallengeCardType, ChallengeFormType } from "../../lib/challengeAPI";

import Header from "../../components/common/Header";
import Navbar from "../../components/common/NavBar";
import Footer from "../../components/common/Footer";
import ChallengeFilter from "../../components/challenge/ChallengeFilter";
import SearchInput from "../../components/common/SearchInput";
import LoadingError from "../../components/common/LoadingError";
import ChallengeSortMenu from "../../components/challenge/ChallengeSortMenu";
import { DataGrid } from "@mui/x-data-grid/DataGrid";
import { allChallengeColumns } from "../../components/analytics/GridViewColumns";
import { useParams } from "react-router-dom";
import { SingleFundFormType } from "../../lib/fundsAPI";
import {
  FundQuickStats,
  FundQuickStatsLoading,
} from "../../components/fund/FundQuickStats";
import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Pagination,
  Select,
  SelectChangeEvent,
  ToggleButton,
  ToggleButtonGroup,
} from "@mui/material";
import { FormatListBulletedSharp, GridView } from "@mui/icons-material";
import React from "react";

const cards = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];

export default function ChallengeIndex() {
  let params = useParams();
  const fundid: number = +params.fundid!;
  const [formData, setFormData] = useState<ChallengeFormType>({
    page_number: 1,
    num_per_page: 12,
    fund_id: Number.isNaN(fundid) ? "All" : [fundid],
    order_by: "challenge_name",
    ordering: "asc",
  });
  console.log(formData);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [formData.page_number, formData.num_per_page]);

  const fundInfo: SingleFundFormType = {
    fund_id: fundid,
  };

  const {
    loading: fund_loading,
    fundData,
    error: fund_error,
  } = useSingleFundData(fundInfo);

  const {
    loading,
    challengesData,
    error: challenge_error,
  } = useAllChallengeData(formData);

  useEffect(() => {
    setFormData({
      ...formData,
      page_number: 1,
      num_per_page: 12,
      fund_id: Number.isNaN(fundid) ? "All" : [fundid],
      order_by: "challenge_name",
      ordering: "asc",
    });
    //eslint-disable-next-line
  }, [fundid]);

  let xl = 4;
  let md = 6;

  const changeNumberPerPage = (event: SelectChangeEvent) => {
    let numberPerPage = parseInt(event.target.value);
    setFormData({
      ...formData,
      num_per_page: numberPerPage,
      page_number: 1,
    });
  };

  const setFundData = (challengeFilterData: any) => {
    setFormData({
      ...formData,
      fund_id: challengeFilterData.fundData,
      challenge_amount: challengeFilterData.challenge_amount,
      number_of_proposals: challengeFilterData.number_of_proposals,
      page_number: 1,
    });
  };

  const [viewStyle, setViewStyle] = useState("grid");
  const goToTop = () => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  };

  const sortPage = (sortData: {
    order_by: string;
    ordering: "asc" | "desc";
  }) => {
    setFormData((prevState) => ({
      ...prevState,
      order_by: sortData.order_by,
      ordering: sortData.ordering,
      page_number: 1,
    }));
  };

  const searchPage = (searchData: string) => {
    setFormData((prevState) => ({
      ...prevState,
      challenge_name: searchData,
      page_number: 1,
    }));
  };

  let challenge_rows: any[] = [];
  challengesData.items.map((challenge: ChallengeCardType) =>
    challenge_rows.push({
      ranking: challenge.ranking,
      name: {
        challenge_id: challenge.challenge_id,
        challenge_name: challenge.challenge_name,
      },
      fund_id: challenge.fund_id,
      fund_name: challenge.fund_name,
      challenge_amount: challenge.challenge_amount,
      number_of_proposals: challenge.number_of_proposals,
      id: challenge.challenge_id,
      amount_requested: challenge.quick_stats_data.amount_requested,
      funded_amount: challenge.quick_stats_data.funded_amount,
      funded_proposals: challenge.quick_stats_data.funded_proposals,
      ideaScale_url: challenge.challenge_url,
      funded_from_leftover: challenge.includes_proposals_sponsored_by_leftovers,
    })
  );

  const handleViewChange = (
    event: React.MouseEvent<HTMLElement>,
    newViewStyle: string
  ) => {
    setViewStyle(viewStyle === "list" ? "grid" : "list");
  };

  return (
    <div>
      <Navbar />
      <Header
        pageName={
          Number.isNaN(fundid) ? "Challenges" : `Challenges in Fund${fundid}`
        }
      />
      {!Number.isNaN(fundid) && (
        <>
          {fund_loading && <FundQuickStatsLoading />}

          {!fund_loading && fund_error === null && (
            <FundQuickStats fund_stats={fundData.quick_stats_data} />
          )}
        </>
      )}
      <SideFilterFrame
        headerName="Challenges"
        filter={
          <ChallengeFilter
            setFundData={setFundData}
            showFund={Number.isNaN(fundid)}
            fund_id={fundid}
          />
        }
        sort={
          <>
            <ToggleButtonGroup
              color="primary"
              value={viewStyle}
              exclusive
              onChange={handleViewChange}
              size="small"
            >
              <ToggleButton value="list">
                <FormatListBulletedSharp fontSize="small" />
              </ToggleButton>
              <ToggleButton value="grid">
                <GridView fontSize="small" />
              </ToggleButton>
            </ToggleButtonGroup>
            <ChallengeSortMenu sortPage={sortPage} hideFund={false} />
          </>
        }
        goToTop={goToTop}
        search={
          <SearchInput
            searchPage={searchPage}
            placeholder="Search by Challenge"
          />
        }
      >
        <>
          {loading && viewStyle === "grid" && (
            <Grid container spacing={4} sx={{ justifyContent: "flex-start" }}>
              {cards.map((item) => (
                <Grid
                  xs={12}
                  md={md}
                  xl={xl}
                  key={item}
                  item
                  sx={{ display: "flex", alignSelf: "100%" }}
                >
                  <ChallengeCardLoading />
                </Grid>
              ))}
            </Grid>
          )}
          {!loading && challenge_error && (
            <LoadingError h1="No Challenge Data !" />
          )}
          {!loading && challenge_error === null && viewStyle === "grid" && (
            <>
              <Grid container spacing={4} sx={{ justifyContent: "flex-start" }}>
                {Array.isArray(challengesData.items) &&
                  challengesData.items.map((item, index) => (
                    <Grid
                      xs={12}
                      md={md}
                      xl={xl}
                      item
                      key={index}
                      sx={{ display: "flex", alignSelf: "100%" }}
                    >
                      <ChallengeCard {...item} />
                    </Grid>
                  ))}
              </Grid>
              <div className="pullRight">
                <Box className="paginationContainer">
                  <FormControl sx={{ m: 1, minWidth: 80 }} size="small">
                    <InputLabel id="demo-select-small">Per Page:</InputLabel>
                    <Select
                      labelId="demo-select-small"
                      id="demo-select-small"
                      name="numberPerPage"
                      value={formData.num_per_page.toString()}
                      label="Per Page"
                      onChange={changeNumberPerPage}
                    >
                      <MenuItem value={"12"}>12</MenuItem>
                      <MenuItem value={"24"}>24</MenuItem>
                      <MenuItem value={"36"}>36</MenuItem>
                      <MenuItem value={"48"}>48</MenuItem>
                      <MenuItem value={"60"}>60</MenuItem>
                    </Select>
                  </FormControl>
                  <Pagination
                    count={Math.ceil(
                      challengesData.number_of_rows / formData.num_per_page
                    )}
                    onChange={(
                      event: React.ChangeEvent<unknown>,
                      value: number
                    ) => {
                      setFormData({
                        ...formData,
                        page_number: value,
                      });
                    }}
                    page={formData.page_number}
                  />
                </Box>
              </div>
            </>
          )}

          {viewStyle === "list" && challenge_error === null && (
            <Box sx={{ width: "100%", paddingBottom: "100px" }}>
              <DataGrid
                componentsProps={{
                  pagination: { classes: null },
                }}
                rows={challenge_rows}
                columns={allChallengeColumns}
                pageSize={formData.num_per_page}
                rowsPerPageOptions={[9, 12, 24, 36, 72, 99]}
                disableSelectionOnClick
                autoHeight
                disableColumnFilter
                loading={loading}
                page={
                  formData.page_number - 1 >= 0 ? formData.page_number - 1 : 0
                }
                onPageSizeChange={(newVal) => {
                  setFormData({
                    ...formData,
                    num_per_page: newVal,
                    page_number: 1,
                  });
                }}
                onPageChange={(newVal) => {
                  setFormData({
                    ...formData,
                    page_number: newVal + 1,
                  });
                }}
                paginationMode="server"
                rowCount={challengesData.number_of_rows}
              />
            </Box>
          )}
        </>
      </SideFilterFrame>
      <Footer />
    </div>
  );
}
